import React, { useState, useRef, useEffect } from 'react';
import { useParams, useNavigate } from 'react-router-dom';
import { fetchTrainingVideosByTrainingId } from '../../../../api/trainingVideoApi';
import ProgressBar from '../TrainingModules/ProgressBar';
import VideoModule from '../TrainingModules/VideoModule';
import './TrainingVideos.css';
import { fetchUserDashboard } from '../../../../api/userDashboardApi';
import PDFViewer from '../TrainingModules/PDFViewer';
import { Document, Page, pdfjs } from 'react-pdf';
import pdfImage from '../../../../assets/images/pdf-img.jpg';
import { IoArrowBack } from "react-icons/io5";

pdfjs.GlobalWorkerOptions.workerSrc = `//cdnjs.cloudflare.com/ajax/libs/pdf.js/${pdfjs.version}/pdf.worker.min.js`;

const TrainingVideos = () => {
  const { trainingId } = useParams();
  const navigate = useNavigate();
  const [modules, setModules] = useState([]);
  const [completedCount, setCompletedCount] = useState(0);
  const [activeModuleId, setActiveModuleId] = useState(null);
  const [loading, setLoading] = useState(true);
  const wrapperRef = useRef(null);
  const [examTypeId, setExamTypeId] = useState(null);
  const [selectedPdf, setSelectedPdf] = useState(null);

  useEffect(() => {
    document.title = 'Training - Finhaat Gurukul';
  }, []);

  useEffect(() => {
    const fetchVideos = async () => {
      try {
        const videos = await fetchTrainingVideosByTrainingId(trainingId);
        const initializedModules = (videos || []).map(video => ({
          ...video,
          completed: false,
        }));
        setModules(initializedModules);
        const completed = initializedModules.filter(module => module.completed).length;
        setCompletedCount(completed);
      } catch (error) {
        // console.error('Error fetching training videos:', error);
        setModules([]);
      } finally {
        setLoading(false);
      }
    };
    fetchVideos();
  }, [trainingId]);

  useEffect(() => {
    const fetchDashboardData = async () => {
      const userId = localStorage.getItem('userId');
      try {
        const dashboardData = await fetchUserDashboard(userId);
        // Find the training that matches our trainingId
        const currentTraining = dashboardData.training.find(
          t => t.trainingId === parseInt(trainingId)
        );
        if (currentTraining) {
          setExamTypeId(currentTraining.examTypeId);
        }
      } catch (error) {
        console.error('Error fetching dashboard data:', error);
      }
    };

    fetchDashboardData();
  }, [trainingId]);

  const handleModuleComplete = (id) => {
    setModules(prevModules => {
      const updatedModules = prevModules.map(module =>
        module.trainingVideoId === id ? { ...module, completed: true } : module
      );
      const completed = updatedModules.filter(module => module.completed).length;
      setCompletedCount(completed);
      return updatedModules;
    });
  };

  const handleVideoStart = (id) => {
    setActiveModuleId(id);
  };

  const handleVideoStop = () => {
    setActiveModuleId(null);
  };

  const scrollLeft = () => {
    if (wrapperRef.current) {
      wrapperRef.current.scrollBy({
        left: -320,
        behavior: 'smooth'
      });
    }
  };

  const scrollRight = () => {
    if (wrapperRef.current) {
      wrapperRef.current.scrollBy({
        left: 320,
        behavior: 'smooth'
      });
    }
  };

  const progress = (completedCount / modules.length) * 100;

  return (
    <div className="training-videos">
      <div className="header-section">
        <IoArrowBack
          className="back-icon"
          onClick={() => navigate(-1)}
        />
        <h2 className='PrepareExamH2'>Training Materials</h2>
      </div>
      {loading ? (
        <div className="spinner-container">
          <div className="spinner"></div>
        </div>
      ) : modules.length === 0 ? (
        <div className="no-videos">No videos available for this training.</div>
      ) : (
        <>
          {/* <div className="progress-section">
            <ProgressBar progress={progress} />
            <span className='lessonCss'>{`${completedCount}/${modules.filter(m => m.contentType === 'Video').length} Videos`}</span>
            <div className="scroll-buttons">
              <button className="arrow-button arrow-left" onClick={scrollLeft}>&lt;</button>
              <button className="arrow-button arrow-right" onClick={scrollRight}>&gt;</button>
            </div>
          </div> */}

          {/* {modules.some(module => module.contentType === 'Video' || module.contentType === null) && (
            <div className="progress-section">
              <ProgressBar progress={progress} />
              <span className='lessonCss'>{`${completedCount}/${modules.filter(m => m.contentType === 'Video').length} Videos`}</span>
              <div className="scroll-buttons">
                <button className="arrow-button arrow-left" onClick={scrollLeft}>&lt;</button>
                <button className="arrow-button arrow-right" onClick={scrollRight}>&gt;</button>
              </div>
            </div>
          )} */}

          <div className="modules-container">
            <div className="modules-wrapper" ref={wrapperRef}>
              {modules
                .filter(module => module.contentType === 'Video' || module.contentType === null)
                .map((module) => (
                  <VideoModule
                    key={module.trainingVideoId}
                    module={{
                      id: module.trainingVideoId,
                      title: module.videoTitle,
                      videoUrl: module.videoUrl,
                      videoThumbnailUrl: module.videoThumbnailUrl,
                      videoDesc: module.videoDesc,
                      videoDuration: module.videoDuration,
                      completed: module.completed,
                      mandatoryDuration: module.mandatoryDuration,
                      trainingId: parseInt(trainingId)
                    }}
                    onComplete={() => handleModuleComplete(module.trainingVideoId)}
                    isActive={activeModuleId === module.trainingVideoId}
                    onVideoStart={() => handleVideoStart(module.trainingVideoId)}
                    onVideoStop={handleVideoStop}
                  />
                ))}
            </div>
          </div>

          {modules.some(module => module.contentType === 'PDF') && (
            <div className="mt-8">
              <h2 className='PrepareExamH2'>Documents</h2>
              <div className="grid grid-cols-1 sm:grid-cols-2 md:grid-cols-3 gap-4 mt-4">
                {modules
                  .filter(module => module.contentType === 'PDF')
                  .map((pdf) => (
                    <div
                      key={pdf.trainingVideoId}
                      className="bg-white rounded-lg shadow-sm border border-gray-200 overflow-hidden cursor-pointer hover:shadow-md transition-shadow"
                      onClick={() => setSelectedPdf(pdf.videoUrl)}
                    >
                      <div className="aspect-video bg-gray-100 relative">
                        <img
                          // src={pdf.videoThumbnailUrl || 'https://via.placeholder.com/400x225?text=PDF+Document'}
                          src={pdfImage}
                          alt={pdf.videoTitle}
                          className="w-full h-full object-cover"
                        />
                        <div className="absolute inset-0 bg-black bg-opacity-40 flex items-center justify-center">
                          <span className="text-white text-lg font-medium">PDF</span>
                        </div>
                      </div>
                      <div className="p-4">
                        <h3 className="text-lg font-semibold text-gray-900 mb-2">{pdf.videoTitle}</h3>
                        <p className="text-sm text-gray-600 line-clamp-2">{pdf.videoDesc}</p>
                      </div>
                    </div>
                  ))}
              </div>
            </div>
          )}
        </>
      )}

      {selectedPdf && (
        <PDFViewer
          pdfUrl={selectedPdf}
          onClose={() => setSelectedPdf(null)}
        />
      )}
    </div>
  );
};

export default TrainingVideos;
